import { baseApi } from '../../../rtk/api';
import { EmailListResponse } from '../sequence-slice';
import {
  EmailStatusOfStepRequestPayload,
  EmailStatusOfStepResponsePayload,
  EmailStepsOfStatusRequestPayload,
  EmailStepsOfStatusResponsePayload,
  GetEmailRequestPayload,
} from '../types/emails';

// Build params object with only keys that are not null and not ""
const buildParamsObj = (params) =>
  Object.entries(params).reduce((acc, [key, value]) => {
    if (
      value !== null &&
      value !== undefined &&
      (key === 'search' || !(typeof value === 'string' && value.trim() === ''))
    ) {
      acc[key] = value;
    }
    return acc;
  }, {} as Record<string, any>);

export const sequenceApis = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSequenceEmails: builder.query<EmailListResponse, GetEmailRequestPayload>(
      {
        query: (args) => {
          const { sequenceId, ...rest } = args;

          const params = buildParamsObj(rest);

          return {
            url: `/sequences/${sequenceId}/emails`,
            params,
          };
        },
        providesTags: ['SequenceEmails'],
        keepUnusedDataFor: 5,
        transformResponse: (response: { payload: EmailListResponse }) =>
          response.payload,
      },
    ),
    getEmailStatusOfStep: builder.query<
      EmailStatusOfStepResponsePayload,
      EmailStatusOfStepRequestPayload
    >({
      query: (args) => {
        const { sequenceId, ...rest } = args;

        const params = buildParamsObj(rest);

        return {
          url: `sequences/${sequenceId}/emails/status-count`,
          params,
        };
      },
      providesTags: ['SequenceEmails'],
      keepUnusedDataFor: 5,
      transformResponse: (response: {
        payload: EmailStatusOfStepResponsePayload;
      }) => response.payload,
    }),
    getEmailStepsOfStatus: builder.query<
      EmailStepsOfStatusResponsePayload,
      EmailStepsOfStatusRequestPayload
    >({
      query: (args) => {
        const { sequenceId, ...rest } = args;

        const params = buildParamsObj(rest);

        return {
          url: `sequences/${sequenceId}/emails/step-count`,
          params,
        };
      },
      providesTags: ['SequenceEmails'],
      keepUnusedDataFor: 5,
      transformResponse: (response: {
        payload: EmailStepsOfStatusResponsePayload;
      }) => response.payload,
    }),
  }),
});

export const {
  useGetSequenceEmailsQuery,
  useGetEmailStatusOfStepQuery,
  useGetEmailStepsOfStatusQuery,
} = sequenceApis;
